<template>
  	<div class="module_page page_content institution admin_ecom" aria-label="Institution Summary view content page">

    <div class="row page-heading">
      <div class="col-2 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-10 right-container">
      </div>
    </div>

	    <div class="page_content_container">
          <template v-if="isNotCustomAdmin">
            <institution-menu :uuid="uuid" :active="'paymentgateway'"></institution-menu>
          </template>
          <template v-if="isCustomAdmin">
            <institution-menu-new :uuid="uuid" :active="'paymentgateway'"></institution-menu-new>
          </template>
		      <div class="row pg_content">
			      <div class="col-12 lst_container_v22">
		          <b-jumbotron>
                <template v-if="!showLoader">
                    <template v-if="isPaymentGatewayEnabled">

                      <!-- Stripe Connect -->
                      <div class="row lst_row">

                        <div class="col-2 thumbnail_container ace_sec">
                          <div class="ic_container stripe">
                            <span class="ic ic22-Stripe-Logo"></span>
                          </div>
                        </div>

                        <div class="col-8 entity_detail_section">
                          <div class="row">
                            <div class="col-12 title">
                              <span class="title_txt">
                                Stripe Connect
                              </span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 other_details">
                              <template v-if="!paymentGateway.setupComplete">
                                <div class="ace_sec_txt hd_info">Click on the 'connect' button to integrate with Stripe</div>
                              </template>
                              <template v-if="paymentGateway.setupComplete">
                                <div class="ace_sec_txt hd_info">Last Updated on {{Date(paymentGateway.lastUpdatedTime)}}</div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <div class="col-2 switch_container">
                          <b-link v-if="!paymentGateway.setupComplete" class="btn" aria-label="connect" :href="stripeConnectLink">Connect</b-link>
                          <div class="switch" v-if="paymentGateway.setupComplete">
                            <div class="lebel_txt">connect to stripe</div>
                            <switches v-model="isStripeConnected" disabled text-enabled="Yes" text-disabled="No"></switches>
                            <!--
                            <div class="switch_bx">
                              <div class="connect"></div>
                              <div class="status">Yes</div>
                            </div>
                            <p class="ace_sec_txt text-green">Connection with Stripe Successful!</p>
                            -->
                          </div>
                        </div>

                      </div>
                      <!-- Stripe Connect Ends -->

                      <!-- Pricing Plans -->
                      <div class="row lst_row">

                        <div class="col-2 thumbnail_container ace_sec">
                          <div class="ic_container pricing">
                            <span class="ic ic22-price"></span>
                          </div>
                        </div>

                        <div class="col-8 entity_detail_section">
                          <div class="row">
                            <div class="col-12 title">
                              <span class="title_txt">
                                Pricing Plans
                              </span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 other_details">
                              <div class="ace_sec_txt hd_info">Manage Pricing Plans. Assign them to programs.</div>
                            </div>
                          </div>
                        </div>

                        <div class="col-2 btn_container">
                          <b-btn v-if="paymentGateway.setupComplete" @click="navigateToPricingPlans" class="btn" aria-label="connect">Go</b-btn>
                        </div>

                      </div>
                      <!-- Pricing Plans Ends -->

                      <!-- Coupons -->
                      <div class="row lst_row">

                        <div class="col-2 thumbnail_container ace_sec">
                          <div class="ic_container coupon">
                            <span class="ic ic22-coupon"></span>
                          </div>
                        </div>

                        <div class="col-8 entity_detail_section">
                          <div class="row">
                            <div class="col-12 title">
                              <span class="title_txt">
                                Coupon Codes
                              </span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 other_details">
                              <div class="ace_sec_txt hd_info">Manage Coupon Codes. Assign them to programs.</div>
                            </div>
                          </div>
                        </div>

                        <div class="col-2 btn_container">
                          <b-btn v-if="paymentGateway.setupComplete" @click="navigateToCouponCodes" class="btn" aria-label="connect">Go</b-btn>
                        </div>

                      </div>
                      <!-- Coupons Ends -->

                      <!-- Transactions -->
                      <div class="row lst_row">

                        <div class="col-2 thumbnail_container ace_sec">
                          <div class="ic_container transactions">
                            <span class="ic ic22-transaction"></span>
                          </div>
                        </div>

                        <div class="col-8 entity_detail_section">
                          <div class="row">
                            <div class="col-12 title">
                              <span class="title_txt">
                                Transactions
                              </span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 other_details">
                              <div class="ace_sec_txt hd_info">Manage Transactions and issue refunds.</div>
                            </div>
                          </div>
                        </div>

                        <div class="col-2 btn_container">
                          <b-btn v-if="paymentGateway.setupComplete" @click="navigateToTransactions" class="btn" aria-label="connect">Go</b-btn>
                        </div>

                      </div>

                      <!-- Transactions Ends -->
                    </template>
                    <template v-if="!isPaymentGatewayEnabled">
                      <h4 class="text-center ace_sec_txt">Please reach out to support@pragyasystems.com to enable this feature.</h4>
                    </template>
                  </template>
                <template v-if="showLoader">
                  <p class="text-center ace_sec_txt pt-4">Loading...</p>
                </template>
		          </b-jumbotron>
			      </div>
		      </div>
	    </div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionMenuNew from './InstitutionMenuNew'
import InstitutionHeader from './InstitutionHeader'
import { PACKAGE } from '../../../package_constants'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'institutionPaymentGateway',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionMenuNew,
    InstitutionHeader,
    Editor
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      paymentGateway: {},
      stripeConnectLink: "",
      showLoader: false,
      isStripeConnected: true
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadLogDashboardActivity',
      'loadInstitutionPaymentGateway',
      'loadStripeConnectUrl'
    ]),

    async loadInstitution () {
      this.showLoader = true
      await this.loadLogDashboardActivity({action: 'viewInstitutionSummaryView', page: 'institutionSummaryView', link: '', entityUuid: this.uuid})
      await this.loadInstitutionDetail(this.uuid)
      this.paymentGateway = await this.loadInstitutionPaymentGateway()
      if (!this.paymentGateway.setupComplete) {
        this.stripeConnectLink = await this.loadStripeConnectUrl()
      }
      this.showLoader = false
    },
    navigateToPricingPlans () {
      return this.$router.push({ name: 'institutionPricingPlans', params: { uuid: this.uuid } })
    },
    navigateToCouponCodes () {
      return this.$router.push({ name: 'institutionCouponCodes', params: { uuid: this.uuid } })
    },
    navigateToTransactions () {
      return this.$router.push({ name: 'institutionTransactions', params: { uuid: this.uuid } })
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
    }),
    isCustomAdmin () {
      return (this.uObj && this.uObj.customAdmin)
    },
    isNotCustomAdmin () {
      let currentUser = JSON.parse(localStorage.getItem('userobj'))
      return !(currentUser && currentUser.customAdmin)
    },
    isPaymentGatewayEnabled () {
      let paymentGateway = this.enabledFeatures[PACKAGE.FEATURE_IDS.PAYMENT_INTEGRATION]
      if (paymentGateway) {
        return paymentGateway.enabled
      }
      return false
    }
  },
  watch: {
  }
}
</script>
<style>
.text-green {
  color: green;
}

.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionPaymentGateway.vue